import "../Styles/index.scss";

import Flickity from "flickity";
import tippy from "tippy.js";

import "./navigation-overlay.svelte";
import "./favorites/favorite-button.svelte";
import "./favorites/favorite-list-button.svelte";
import "./newsletter/newsletter-signup.svelte";

if (document.querySelector("bluc-map") != null) {
	import("./bluc-map.svelte");
}
if (document.querySelector("favorite-list") != null) {
	import("./favorites/favorite-list.svelte");
}
if (document.querySelector("event-registration") != null) {
	import("./events/event-registration.svelte");
}
if (document.querySelector("host-registration") != null) {
	import("./host-registration/host-registration.svelte");
}
if (document.querySelector("event-filter") != null) {
	import("./events/event-filter.svelte");
}

tippy("[data-tippy-content]");

const flickityArrowShape = "m93.89,50.4c0,3.53-2.87,6.4-6.4,6.4h-46.43v15.8c0,5.4-6.31,8.4-10.49,4.9-9.79-8.18-15.39-13.94-23.62-24.08-1.43-1.76-1.43-4.29,0-6.05,8.22-10.13,13.83-15.89,23.62-24.08,4.18-3.49,10.49-.49,10.49,4.91v15.8h46.43c3.53,0,6.4,2.87,6.4,6.4Z";

let carouselElements = document.querySelectorAll("[data-carousel]");
for (let element of carouselElements) {
	if (element.childElementCount <= 1) {
		continue;
	}

	new Flickity(element, {
		arrowShape: flickityArrowShape
	});
}

let galleryElements = document.querySelectorAll(".asset-list--image, .image-gallery-block__images");
for (let element of galleryElements) {
	if (element.childElementCount <= 1) {
		continue;
	}

	new Flickity(element, {
		arrowShape: flickityArrowShape,
		pageDots: false,
	});
}

import { init } from "@plausible-analytics/tracker";
init({
	domain: "informatiktage.ch",
	outboundLinks: true
});
